/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-string-refs */
import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import "./notificationWrapper.css";

export class NotificationComponent extends Component {
  componentDidMount() {
    /**
         * gets reference of notification system into "this" context.
         */
    this._notificationSystem = this.refs.notificationSystem;
  }

  /**
     * used to show notifications
     * @param type
     * @param msg
     * @private
     */
  // eslint-disable-next-line react/no-unused-class-component-methods
  _addNotification(type, msg) {
    this._notificationSystem.addNotification({
      message: msg,
      level: type,
      success: {
        color: "green",
      },
      error: {
        color: "rgb(228, 190, 190)",
      },
    });
  }

  render() {
    return (
      <div className="notificationStyle">
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}
